<template>
  <div class="registerform__step step__three">
    <div class="step__content">
      <form class="step__form">
        <div class="form__headline">
          <h4 class="-color-alpha">Ihre Kontaktdaten:</h4>
        </div>
        <div class="form__form">
          <div class="field__wrap field__wrap--two-col -smaller-spacing">
            <div class="col col-one">
              <CmInputTypeSelect
                label="Anrede"
                :bold="true"
                identifier="salutation"
                v-model="registerform.contact.salutation"
                :options="salutationOptions"
                :error="error && salutationIsMissing"></CmInputTypeSelect>
            </div>
          </div>
          <div class="field__wrap field__wrap--two-col -smaller-spacing">
            <div class="col col-one">
              <TextInput
                label="Vorname"
                :bold="true"
                identifier="firstname"
                v-model="registerform.contact.firstname"
                :error="error && firstnameIsMissing"></TextInput>
            </div>
            <div class="col col-two">
              <TextInput
                label="Nachname"
                :bold="true"
                identifier="lastname"
                v-model="registerform.contact.lastname"
                :error="error && lastnameIsMissing"></TextInput>
            </div>
          </div>
          <div class="field__wrap field__wrap--two-col -smaller-spacing">
            <div class="col col-one">
              <TextInput
                label="Firma"
                :bold="true"
                identifier="company"
                v-model="registerform.contact.company"
                :error="error && companyIsMissing"></TextInput>
            </div>
          </div>
          <div class="field__wrap field__wrap--two-col -smaller-spacing">
            <div class="col col-one">
              <TextInput
                label="PLZ"
                :bold="true"
                identifier="zip"
                v-model="registerform.contact.zip"
                :error="error && zipIsMissing"></TextInput>
            </div>
            <div class="col col-two">
              <TextInput
                label="Ort"
                :bold="true"
                identifier="city"
                v-model="registerform.contact.city"
                :error="error && cityIsMissing"></TextInput>
            </div>
          </div>
          <div class="field__wrap field__wrap--two-col -smaller-spacing">
            <div class="col col-one">
              <TextInput
                label="E-Mail"
                :bold="true"
                identifier="email"
                v-model="registerform.contact.email"
                :error="error && emailIsMissing"></TextInput>
            </div>
            <div class="col col-two">
              <TextInput
                label="Telefonnummer"
                :bold="true"
                identifier="phone"
                v-model="registerform.contact.phone"
                :error="error && phoneIsMissing"></TextInput>
            </div>
          </div>
          <div class="field__wrap field__wrap--one-col -smaller-spacing">
            <div class="col">
              <TextInput
                label="Wann sind Sie am besten erreichbar?"
                :bold="true"
                identifier="availability"
                v-model="registerform.contact.availability"
                :error="error && availabilityIsMissing"></TextInput>
            </div>
          </div>
          <div class="field__wrap -smaller-spacing -privacy">
            <div class="col">
              <Checkbox
                identifier="privacy"
                v-model="registerform.contact.privacy"
                @updateValue="registerform.contact.privacy = $event"
                :error="error && privacyIsMissing"><span>Mit Setzen des Hakens erkläre ich mich einverstanden, dass die von mir erhobenen Daten für die Bearbeitung meiner Anfrage elektronisch erhoben und gespeichert werden. Diese Einwilligung kann jederzeit mit einer Nachricht an uns widerrufen werden. Weitere Informationen entnehmen Sie der <a :href="privacyPage" target="_blank">Datenschutzerklärung</a>.*</span></Checkbox>
            </div>
          </div>
        </div>
        <div class="form__action">
          <div class="-btn-alpha" @click="nextStep()"><span>Absenden</span></div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import TextInput from '@/components/form/CmInputTypeText'
import Checkbox from '@/components/form/CmInputTypeCheckbox'
import CmInputTypeSelect from "@/components/form/CmInputTypeSelect";
export default {
  name: 'Form',
  props: ['registerform', 'privacyPage'],
  data () {
    return {
      error: false,
      salutationOptions: [
        {
          label: 'Herr',
          value: 'Herr'
        },
        {
          label: 'Frau',
          value: 'Frau'
        }
      ]
    }
  },
  components: {
    CmInputTypeSelect,
    TextInput,
    Checkbox
  },
  computed: {
    salutationIsMissing: function () {
      return !this.registerform.contact.salutation
    },
    firstnameIsMissing: function () {
      return !this.registerform.contact.firstname
    },
    lastnameIsMissing: function () {
      return !this.registerform.contact.lastname
    },
    companyIsMissing: function () {
      return !this.registerform.contact.company
    },
    zipIsMissing: function () {
      return !this.registerform.contact.zip
    },
    cityIsMissing: function () {
      return !this.registerform.contact.city
    },
    emailIsMissing: function () {
      return !this.registerform.contact.email
    },
    phoneIsMissing: function () {
      return !this.registerform.contact.phone
    },
    availabilityIsMissing: function () {
      return !this.registerform.contact.availability
    },
    privacyIsMissing: function () {
      return !this.registerform.contact.privacy
    },
    allFieldsFilled: function () {
      return !this.salutationIsMissing && !this.firstnameIsMissing && !this.lastnameIsMissing && !this.companyIsMissing && !this.zipIsMissing && !this.cityIsMissing && !this.emailIsMissing && !this.phoneIsMissing && !this.availabilityIsMissing && !this.privacyIsMissing
    }
  },
  methods: {
    nextStep: function () {
      if (this.allFieldsFilled) {
        this.error = false
        this.$emit('handleRequest', this.registerform)
      } else {
        this.error = true
      }
    }
  }
}
</script>
